import { useAuth } from "../../hooks/AuthProvider";
import { useState } from "react";
import LoadingScreen from "../LoadingScreen";

const Login = () => {
  const { handleLogin } = useAuth();
  const [loading, setLoading] = useState(false);

  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const { email, password } = inputs;

  const onChange = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { email, password };
    setLoading(true);

    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const parsedResp = await response.json();

      setInputs({
        email: "",
        password: "",
      });

      if (!response.ok) {
        return console.log("not ok!", response, parsedResp.msg);
      }

      handleLogin(parsedResp.token);
    } catch (err) {
      console.log(err.message);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          <h1 className="text-center my-5">Login</h1>
          <form onSubmit={(e) => handleSubmit(e)}>
            <input
              type="email"
              name="email"
              placeholder="email"
              className="form-control my-3"
              value={email}
              required
              onChange={(e) => onChange(e)}
            />
            <input
              type="password"
              name="password"
              placeholder="password"
              className="form-control my-3"
              value={password}
              required
              onChange={(e) => onChange(e)}
            />
            <button className="btn btn-success d-block">Submit</button>
          </form>
        </>
      )}
    </>
  );
};
export default Login;
